const PROJECT_TYPE_MAP = {
  web_store: 'Web Store',
  payment_links: 'Payment Links',
  web_checkout: 'Web Checkout'
};

export const getSolutionModelInfo = (isWebStore: boolean, isPaymentLinks: boolean) => {
  if (isWebStore) return PROJECT_TYPE_MAP.web_store;
  if (isPaymentLinks) return PROJECT_TYPE_MAP.payment_links;
  return PROJECT_TYPE_MAP.web_checkout;
};
